import * as React from 'react';

import Text from '../../../../text/Text.jsx';

export type SurveyStartTeaserSlideProps = {
  headline: React.ReactNode;
  children?: React.ReactNode;
};

const SurveyStartTeaserSlide = ({
  headline,
  children
}: SurveyStartTeaserSlideProps) => (
  <div className="survey-start-teaser-slide keen-slider__slide">
    <Text
      className="survey-start-teaser-slide__headline"
      variant="headline-5"
      tag="h3"
    >
      {headline}
    </Text>

    {children}
  </div>
);

export default SurveyStartTeaserSlide;
